import React from 'react';
import EmptyDropPlaceholder from '../../EmptyDropPlaceholder';
import {sections} from '../../constants';

const SectionList = ({
    pageSections,
    pageId,
    moveTheSection,
    showDeleteSectionDialog,
    showEnableSectionDialog,
    showDisableSectionDialog,
    hideActions
}) => {

    return (
        <div>
            <EmptyDropPlaceholder index={-1} />
            {pageSections.map((section, i) => {
                const Section = sections[section.type_id];
                return (
                    <div key={i}>
                        <Section
                            hideDragIcon={false}
                            blockId={section.block ? section.block.id : null}
                            blockType={section.block ? 'Text Block' : null}
                            blockTypeId={section.block ? section.block.block_type_id : null}
                            deletable={section.type_id === 1 ? true: false}
                            sectionType={section.section_type}
                            sectionTypeId={section.type_id}
                            index={i}
                            visible={section.is_visible === 1 ? true : false}
                            id={section.id}
                            pageId={pageId}
                            sectionUniqueId={section.uniqueId}
                            new={section.new}
                            touched={section.touched}
                            placeholderName={section.placeholder_name}
                            moveSection={moveTheSection}
                            deleteSection={showDeleteSectionDialog}
                            enableSection={showEnableSectionDialog}
                            disableSection={showDisableSectionDialog}
                            hideActions={hideActions}
                        />
                        <EmptyDropPlaceholder index={i} />
                    </div>
                )
            })}
        </div>
    )
};

export default SectionList;


// WEBPACK FOOTER //
// ./src/containers/templates/builder/sections/tab_dnd/SectionList.jsx